var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBold48Line = function SvgIconBold48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.93 23.59A7.778 7.778 0 0 0 33.3 18c0-4.3-3.5-7.8-7.8-7.8h-7.8c-1.65 0-3 1.35-3 3v21.6c0 1.65 1.35 3 3 3h8.8c4.3 0 7.8-3.5 7.8-7.8 0-2.66-1.34-5-3.37-6.41Zm-11.78-8.94h6.14c1.97 0 3.56 1.6 3.56 3.56s-1.6 3.56-3.56 3.56h-6.14v-7.13.01Zm7.14 18.7h-7.14v-7.13h7.14c1.97 0 3.56 1.6 3.56 3.56s-1.6 3.56-3.56 3.56v.01Z",
    fill: "current"
  })));
};
export default SvgIconBold48Line;